import {FC} from 'react'
import {Button} from '@components/ui/button'
import {SuccessIcon} from '@features/user/components/forgot-password-icon'
import {ModalBody, ModalFooter} from '@components/ui/modal-atoms'
import {Dialog, DialogContent} from '@components/ui/dialog'

interface SuccessModalProps {
    onClose?: () => void
    onClickCta: () => void
    buttonLabel: string
    paragraph: string
}

export const SuccessModal: FC<SuccessModalProps> = ({onClose, onClickCta, buttonLabel, paragraph}) => {
    return (
        <Dialog open onOpenChange={open => !open && onClose?.()}>
            <DialogContent className="w-100" showCloseButton={false}>
                <ModalBody className="items-center text-md font-medium">
                    <SuccessIcon size={64} />
                    <p>{paragraph}</p>
                </ModalBody>
                <ModalFooter>
                    <Button className="w-full" onClick={onClickCta}>
                        {buttonLabel}
                    </Button>
                </ModalFooter>
            </DialogContent>
        </Dialog>
    )
}
